import React from 'react'
import {
  LocationDetailsMap,
  NoResults,
  RPCDocs,
  RPCs,
  useRPC,
} from '@therms/react-modules'
import {
  Card,
  DataDisplay,
  Icon,
  Modal,
  useContainerDimensionsContext,
} from '@therms/atalaya'
import {MdMap, MdNfc, MdOutlineQrCode} from 'react-icons/md'

interface CheckpointDetailModalProps {
  checkpointId: string
  onClose: () => void
}

function CheckpointDetailModal({
  checkpointId,
  onClose,
}: CheckpointDetailModalProps) {
  const {data} = useRPC<
    RPCDocs.Locations.GetLocationCheckpointDetail.v1.Args,
    RPCDocs.Locations.GetLocationCheckpointDetail.v1.Data
  >(
    RPCs.Locations.GetLocationCheckpointDetail.v1,
    {checkpointId},
    {cacheStrategy: 'cache-only'},
  )

  const {heightForBottomOfScreen} = useContainerDimensionsContext()

  return (
    <Modal
      closeHandler={onClose}
      escPressClose
      header={
        <div className="gap-x-sm inline-flex text-lg">
          <div className="inline-flex items-center justify-center uppercase">
            <Icon
              className="mr-xs"
              Icon={data?.checkpoint.type === 'qr' ? MdOutlineQrCode : MdNfc}
            />

            <span className="text-color-neutral-faded font-light">
              {data?.checkpoint.type}{' '}
            </span>
          </div>
          <span>{data?.checkpoint.name}</span>
        </div>
      }
    >
      <Card padding="xs" space="xs">
        <DataDisplay>
          {data?.checkpoint.description && (
            <DataDisplay.Item label="Checkpoint Description">
              <div className="">{data?.checkpoint.description}</div>
            </DataDisplay.Item>
          )}

          {data?.checkpoint.scan.instructions && (
            <DataDisplay.Item label="Scan Instructions">
              <div className="">{data?.checkpoint.scan.instructions}</div>
            </DataDisplay.Item>
          )}

          {data?.checkpoint.scan.description && (
            <DataDisplay.Item label="Scan Description">
              <div className="">{data?.checkpoint.scan.description}</div>
            </DataDisplay.Item>
          )}
        </DataDisplay>

        {data?.checkpoint.geo?.coordinates ? (
          <LocationDetailsMap
            highlightedCheckpointId={data.checkpoint.id}
            mapHeight={heightForBottomOfScreen - 100}
          />
        ) : (
          <NoResults
            text="No Geo Coordinates for this Checkpoint"
            iconName={MdMap}
          />
        )}
      </Card>
    </Modal>
  )
}

export {CheckpointDetailModal}
